import type { PropsWithChildren } from 'react';
import { createContext, useContext, useEffect } from 'react';

const handleTouchStart = (e: TouchEvent) => {
  document.body.style.setProperty('--click-x', `${e.touches[0].clientX}px`);
  document.body.style.setProperty('--click-y', `${e.touches[0].clientY}px`);
};

type MousePositionEvent = { clientX: number; clientY: number };
const handleMouseDown = (e: MousePositionEvent) => {
  document.body.style.setProperty('--click-x', `${e.clientX}px`);
  document.body.style.setProperty('--click-y', `${e.clientY}px`);
};

const MousePositionContext = createContext<{
  handleMouseDown: (e: MousePositionEvent) => void;
  handleTouchStart: (e: TouchEvent) => void;
}>({ handleMouseDown, handleTouchStart });

export const MousePositionProvider = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('touchstart', handleTouchStart);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('touchstart', handleTouchStart);
      document.body.style.removeProperty('--click-x');
      document.body.style.removeProperty('--click-y');
    };
  }, []);

  return (
    <MousePositionContext.Provider
      value={{ handleMouseDown, handleTouchStart }}
    >
      {children}
    </MousePositionContext.Provider>
  );
};

export const useMousePositionContext = () => useContext(MousePositionContext);
